const store = require('store/Store');
const TestTargetActions = require('actions/TestTargetActions');
const InflatorComps = require('utils/framework/InflateComponents');
const services = InflatorComps.services;
const Events = require('utils/framework/Events');
const TestTargetUtils = require('utils/TestTarget');
const shouldServiceRun = require('utils/Services').shouldServiceRun;

// const store = require('store/Store');
const watch = require('redux-watch');

const LOCAL_STORAGE = require('utils/localStorage/Constants');
const Storage = require('utils/localStorage/Storage');
const Perf = require('utils/framework/Perf');

/**
 * Processes test results and stores them in the Store
 */
function processTests(result) {
    for (let prop in result) {
        if (Object.prototype.hasOwnProperty.call(result, prop)) {
            let currentTest = result[prop];

            switch (currentTest.testType) {
                case TestTargetUtils.TEST_TYPES.REORDERING:
                    /* Transform the component arrangement format prescribed by T&T to ease the
                    swapping process. */
                    TestTargetUtils.setComponentArrangement.apply(currentTest);

                    /* Components being swapped in the same test need a common reference object
                    in the store to exchange data. */
                    store.dispatch(TestTargetActions.registerTest(prop));
                    break;

                case TestTargetUtils.TEST_TYPES.SHOW_CERTONA_IN_INLINEBASKET:
                    store.dispatch(
                        TestTargetActions.showCertonaInInlineBasket(currentTest.showCertonaRecs)
                    );
                    break;

                // [UBS-72] - Remove after test is done
                case TestTargetUtils.TEST_TYPES.SHOW_CCPA_BANNER:
                    if (Sephora.configurationSettings.showCCPABanner) {
                        Sephora.configurationSettings.isCCPABannerEnabled = currentTest.showBanner;
                    }
                    break;
                    // [UBS-72] - Remove after test is done />

                // [UBS-173] - Remove after test is done
                case TestTargetUtils.TEST_TYPES.UPDATE_CCPA_BANNER_COPY:
                    Sephora.configurationSettings.isCCPABannerEnabled = true;
                    break;
                    // [UBS-173] - Remove after test is done />

                default:
                    break;
            }
        }
    }

    store.dispatch(TestTargetActions.setOffers(result));
}

/** Requests T&T tests and applies them
 * @param {Object} targetParams - user/page data sent to T&T, refer to utils/TestTarget.js.
 * @param {Function} callback - optional callback
 */
function getOffer(targetParams, callback) {

    adobe.target.getOffer({
        mbox: TestTargetUtils.MBOX_NAME,
        params: targetParams,
        success: response => {
            try {
                // TODO: revisit/remove when we migrate to only support JSON offers
                let totalTests = TestTargetUtils.getTotalDeliveredTests(response);
                store.dispatch(TestTargetActions.setTotalTests(totalTests));

                adobe.target.applyOffer({
                    mbox: TestTargetUtils.MBOX_NAME,
                    offer: response
                });

                /* Immediately processing sync tests, setup with JSON Offers */
                if (Array.isArray(response)) {
                    let jsonTests = response.filter(
                        test => test.action === TestTargetUtils.JSON_ACTION);
                    if (jsonTests.length) {
                        jsonTests.forEach(test => {
                            let offers = test.content.reduce(function (result, item) {
                                Object.keys(item).forEach(key => {
                                    result[key] = item[key];
                                });
                                return result;
                            }, {});
                            processTests(offers);
                        });
                    } else {
                        store.dispatch(TestTargetActions.setOffers(
                            Sephora.configurationSettings.ABTests || {}
                        ));
                    }

                }

            } catch (e) {
                console.error(e);
                store.dispatch(TestTargetActions.cancelOffers(true));

                if (callback) {
                    callback();
                }
            }
        },

        error: (status, error) => {
            store.dispatch(TestTargetActions.cancelOffers(true));

            if (callback) {
                callback();
            }

        },

        timeout: TestTargetUtils.MBOX_TIMEOUT
    });
}

/**
 * Sets service as ready
 */
function serviceReady() {
    Sephora.Util.InflatorComps.services.loadEvents.TestTargetReady = true;
    Perf.report('TestTarget Ready');
    window.dispatchEvent(new CustomEvent(Events.TestTargetReady, { detail: {} }));
}

function handleCostumerIds() {
    var ATGIDCookie = document.cookie.split('DYN_USER_ID=')[1];

    if (ATGIDCookie) {
        const ATGID = ATGIDCookie.split(';')[0];
        const idObject = {
            'id': ATGID,
            'authState': 1 // Visitor.AuthState.AUTHENTICATED
        };

        visitor.setCustomerIDs({
            customerid: idObject,
            contentid: idObject
        });
    }
}

let testTargetStoreListeners = [];

module.exports = function ({ doNotResetTestAndTarget } = {}) {
    /* Stop service from loading if not necessary */
    if (!shouldServiceRun.testTarget()) {
        return false;
    }

    if (testTargetStoreListeners.length) {
        for (let unsubscribe of testTargetStoreListeners) {
            typeof unsubscribe === 'function' && unsubscribe();
        }
        testTargetStoreListeners = [];
    }

    const ABTests = Sephora.configurationSettings.ABTests || {};

    if (!doNotResetTestAndTarget) {
        store.dispatch(TestTargetActions.forceReset(ABTests));
    }

    /* Adobe Test & Target Service
     ** The at.js script is loaded asynchronously and contains the following custom code
     ** which is executed at the end of the script:
     ** 1. window.dispatchEvent(new CustomEvent('TestTargetLoaded', {'detail': {}}));
     ** 2. Sephora.Util.InflatorComps.services.loadEvents.TestTargetLoaded = true;
     */

    const userLocalData = Storage.local.getItem(LOCAL_STORAGE.USER_DATA, true);

    /* We check for a localStorage version of sent user target params or user data to avoid relying
     ** on userInfo if unnecessary. If no cache exists then we load user data from the userInfo
     ** service data.
     */

    const skipUserFull =
        Boolean(userLocalData || !Sephora.Util.TestTarget.isRecognized);

    const serviceDependencies = skipUserFull ?
        [Events.TestTargetLoaded, Events.VisitorAPILoaded]
        : [Events.UserInfoReady, Events.TestTargetLoaded, Events.VisitorAPILoaded];

    Sephora.Util.TestTarget.waitedForUserFull = !skipUserFull;

    /* Actual service logic */
    Events.onLastLoadEvent(window, serviceDependencies, () => {
        const userData = Sephora.Util.TestTarget.isRecognized ?
            (userLocalData || services.UserInfo.data.profile) : {};

        TestTargetUtils.setUserParams(userData)
            .then((targetParams)=>{
                /* Set TestTargetReady only when amount of dispatched tests matches the
            amount of total tests delivered or there are no tests at all. */
                let testTargetWatcher = watch(store.getState, 'testTarget');
                let offersUnsubscribe = store.subscribe(testTargetWatcher(state => {
                    if (state.totalTests === 0 || state.totalTests === state.receivedTests) {
                        serviceReady();
                    }
                }), { ignoreAutoUnsubscribe: true });
                testTargetStoreListeners.push(offersUnsubscribe);

                /* Listener for processing async tests, setup with HTML Offers */
                window.addEventListener(Events.TestTargetResult, data => processTests(data.detail.result));

                getOffer(targetParams, serviceReady);

            });
        /* Apply Test&Target offer each time user is updated, but not if said update means
        ** the store is being populated for the first time during page load.
        */

        let userWatch = watch(store.getState, 'user');
        let userUnsubscribe = store.subscribe(userWatch( (newVal, oldVal) => {
            /* Need to check for beautyInsiderAccount since we need to trigger mbox call
            on any user registration */
            const userChanged =
                (newVal.profileId !== oldVal.profileId) ||
                (!oldVal.beautyInsiderAccount && newVal.beautyInsiderAccount);

            if (userChanged && oldVal.isInitialized) {
                handleCostumerIds();
                TestTargetUtils.setUserParams(newVal)
                    .then(( targetParams)=>{
                        getOffer(targetParams);
                    });
            }
        }), { ignoreAutoUnsubscribe: true });
        testTargetStoreListeners.push(userUnsubscribe);
    });

    window.addEventListener(Events.TestTargetReady, () => {
        InflatorComps.renderQueue(Events.TestTarget, false);
    });

    Sephora.Util.InflatorComps.services.loadEvents[Events.TestTargetServiceReady] = true;
    window.dispatchEvent(new CustomEvent(Events.TestTargetServiceReady, { detail: {} }));

    return null;
};
